module.exports = __webpack_public_path__ + "img/mega-down.1ef5e6e4.svg";